import store from '../store';
import RoutingRuleRetainer from './rrdefRetainer';

const changeManager = function(payload) {
  
    this.state = ""
    this.prepareState();

    this.orgEvent = payload.orgEvent; 
    this.orgSrcID = this.orgEvent.src;
    this.orgDstID = this.orgEvent.dst;
    this.orgSrcType = this.findNodeType(this.orgSrcID)
    this.orgDstType = this.findNodeType(this.orgDstID)
    
    this.sourceID = payload.sourceID //newSrc
    this.destinationID = payload.destinationID //newDst    
    this.srcType = this.findNodeType(this.sourceID)
    this.dstType = this.findNodeType(this.destinationID)  
    
    
    this.sourceScenario = null 
    this.destinationScenario = null

    this.srcChangeUts = {
        "deleteIds": [],
        "editObjs": []
    }

    this.dstChangeUts = {
        "deleteIds": [],
        "editObjs": []
    }

    this.userTriggers = {
        "deleteIds": [],
        "editObjs": []
    } 

    this.rrdefs = {
        "deleteIds": [],
        "editObjs": []
    }
    

    this.identifyChangeScenario(); 

    this.handlers = this.manageHandlers({selectedEvent: this.orgEvent, handlers: this.state.constructs.handlers, src: this.sourceID, dst: this.destinationID })
    
    const eventData = JSON.parse(JSON.stringify(payload.orgEvent))
    eventData.src = this.sourceID;
    eventData.dst = this.destinationID;

    const handlerTypes = this.handlers.map(item => item.type)
    if(handlerTypes.includes('onrecv')) eventData.attributes.onrecv = false;
	if(handlerTypes.includes('onsend')) eventData.attributes.onsend = false;
    
    this.combineSrcAndDstChanges();
  

    return {
        event: eventData,
        handlers: this.handlers,
        userTriggers: this.userTriggers,
        rrdefs: this.rrdefs,

    };
}

changeManager.prototype.prepareState = function() {
    
    this.state = store.getState();
}

changeManager.prototype.identifyChangeScenario = function() {
      
    this.identifySourceScenario();      
    this.identifyDestinationScenario();

}


changeManager.prototype.identifySourceScenario = function() {

    if(this.orgSrcID !== this.sourceID){
                
        if(this.orgSrcType === 'delegate' && this.srcType === 'clusterlet') this.srcDelegateToClusterlet()

        if(this.orgSrcType === 'clusterlet' && this.srcType === 'delegate') this.srcClusterletToDelegate()

        if(this.orgSrcType === 'delegate' && this.srcType === 'delegate') this.srcDelegateToDelegate()
    
        if(this.orgSrcType === 'clusterlet' && this.srcType === 'clusterlet') this.srcClusterletToClusterlet()
        
    }
}


changeManager.prototype.identifyDestinationScenario = function() {

    if(this.orgDstID !== this.destinationID){
        
        if(this.orgDstType === 'delegate' && this.dstType === 'clusterlet') this.dstDelegateToClusterlet()

        if(this.orgDstType === 'clusterlet' && this.dstType === 'delegate') this.dstClusterletToDelegate()

        if(this.orgDstType === 'delegate' && this.dstType === 'delegate') this.dstDelegateToDelegate()
    
        if(this.orgDstType === 'clusterlet' && this.dstType === 'clusterlet') this.dstClusterletToClusterlet()
        
    }


}

changeManager.prototype.srcDelegateToClusterlet = function() {

    this.sourceScenario = "delegate_to_clusterlet";

    /**delete user trigger */
    const userTriggers = this.state.constructs.user_triggers.filter(item => item.attributes.op === this.orgEvent.id).map(item => item.id)
    this.srcChangeUts.deleteIds = [ ...this.srcChangeUts.deleteIds, ...userTriggers]

    /**delete rrdef with dir in */
    const rrdefs = this.state.constructs.rrdefs.filter(item => item.attributes.delegate === this.orgSrcID && item.attributes.tcmd === this.orgEvent.id && item.attributes.dir === 'IN').map(item => item.id)
    this.rrdefs.deleteIds = [...this.rrdefs.deleteIds, ...rrdefs]


}

changeManager.prototype.srcClusterletToDelegate = function() {

    this.sourceScenario = "clusterlet_to_delegate";

    /** nothing to do with user triggers */


    /** nothing to do with rrdefs */

}

changeManager.prototype.srcDelegateToDelegate = function() {

    this.sourceScenario = "delegate_to_delegate";

    /**retain user trigger as it is*/

    /**rrdef changes*/
    const protocol = this.state.constructs.clusterlets.find(item => item.id === this.sourceID).attributes.type;
    const orgProtocol = this.state.constructs.clusterlets.find(item => item.id === this.orgSrcID).attributes.type;

    const rrdef = this.state.constructs.rrdefs.find(item => item?.attributes?.delegate === this.orgSrcID && item?.attributes?.tcmd === this.orgEvent.id && item.attributes.dir === 'IN')
    const editedRrdef = new RoutingRuleRetainer({orgRrdef: rrdef, orgProtocol, protocol, delegate: this.sourceID, ttype: this.destinationID })
    // console.log("editedRrdef", editedRrdef)

    this.rrdefs.editObjs = [ ...this.rrdefs.editObjs, editedRrdef]
   
}

changeManager.prototype.srcClusterletToClusterlet = function() {

    this.sourceScenario = "clusterlet_to_clusterlet";

    /**nothing to do with user triggers */

    /**nothing to do with rrdefs*/


    
}

changeManager.prototype.dstDelegateToClusterlet = function() {

    this.destinationScenario = "delegate_to_clusterlet";

    if(this.orgSrcType === 'delegate'){
        
        const userTriggers = JSON.parse(JSON.stringify(this.state.constructs.user_triggers)).filter(item => item.attributes.op === this.orgEvent.id)
        userTriggers.forEach(item => item.attributes.type = this.destinationID)

        this.dstChangeUts.editObjs = [...this.dstChangeUts.editObjs, ...userTriggers]
    }

    /**delete rrdef with dir out */
    const rrdefs = this.state.constructs.rrdefs.filter(item => item.attributes.delegate === this.orgDstID && item.attributes.tcmd === this.orgEvent.id && item.attributes.dir === 'OUT').map(item => item.id)
    this.rrdefs.deleteIds = [...this.rrdefs.deleteIds, ...rrdefs]

}

changeManager.prototype.dstClusterletToDelegate = function() {

    this.destinationScenario = "clusterlet_to_delegate";

    if(this.orgSrcType === 'delegate'){
        
        const userTriggers = JSON.parse(JSON.stringify(this.state.constructs.user_triggers)).filter(item => item.attributes.op === this.orgEvent.id)
        userTriggers.forEach(item => item.attributes.type = this.destinationID)

        this.dstChangeUts.editObjs = [...this.dstChangeUts.editObjs, ...userTriggers]
    }

    /**nothing to do with rrdefs */
}

changeManager.prototype.dstDelegateToDelegate = function() {

    this.destinationScenario = "delegate_to_delegate";

    if(this.orgSrcType === 'delegate'){
        
        const userTriggers = JSON.parse(JSON.stringify(this.state.constructs.user_triggers)).filter(item => item.attributes.op === this.orgEvent.id)
        userTriggers.forEach(item => item.attributes.type = this.destinationID)

        this.dstChangeUts.editObjs = [...this.dstChangeUts.editObjs, ...userTriggers]
    }

    /**rrdefs changes*/
    const protocol = this.state.constructs.clusterlets.find(item => item.id === this.destinationID).attributes.type;
    const orgProtocol = this.state.constructs.clusterlets.find(item => item.id === this.orgDstID).attributes.type;
   
    const rrdef = this.state.constructs.rrdefs.find(item => item?.attributes?.delegate === this.orgDstID && item?.attributes?.tcmd === this.orgEvent.id && item.attributes.dir === 'OUT')
    const editedRrdef = new RoutingRuleRetainer({ orgRrdef: rrdef, orgProtocol, protocol, delegate: this.destinationID, ttype: this.sourceID })

    this.rrdefs.editObjs = [ ...this.rrdefs.editObjs, editedRrdef]
    
}

changeManager.prototype.dstClusterletToClusterlet = function() {

    this.destinationScenario = "clusterlet_to_clusterlet";

    if(this.orgSrcType === 'delegate'){
        
        const userTriggers = JSON.parse(JSON.stringify(this.state.constructs.user_triggers)).filter(item => item.attributes.op === this.orgEvent.id)
        userTriggers.forEach(item => item.attributes.type = this.destinationID)

        this.dstChangeUts.editObjs = [...this.dstChangeUts.editObjs, ...userTriggers]
    }

    /**nothing to do with rrdefs */
    
}


changeManager.prototype.manageHandlers = function({selectedEvent, handlers, src, dst }) {
	// console.log({selectedEvent, handlers, src, dst})

	const luaForEvent = handlers
	.filter(lua => lua.event === selectedEvent.id)
	.filter(item => {
		if(item.type === 'onrecv' && selectedEvent.dst !== dst) {
			return item;
		}
		if(item.type === 'onsend' && selectedEvent.src !== src) {
			return item;
		}
	})
	
	return luaForEvent;
}


changeManager.prototype.findNodeType = function(id) {

    const clusterlet = this.state.constructs.clusterlets.find(item => item.id === id)

    if(clusterlet.type === 1) return "delegate"

    if(clusterlet.type === 2 || clusterlet.type === 3) return 'clusterlet'

}

changeManager.prototype.combineSrcAndDstChanges = function(){

    const userTriggerDeleteIds =  [...new Set([...this.srcChangeUts.deleteIds, ...this.dstChangeUts.deleteIds]) ]
    
    const userTriggerEditObjs = [...this.srcChangeUts.editObjs, ...this.dstChangeUts.editObjs]

    const filterUserTrigerEditObjs = userTriggerEditObjs.filter(item => !userTriggerDeleteIds.includes(item.id));

    this.userTriggers.deleteIds = userTriggerDeleteIds;

    this.userTriggers.editObjs = filterUserTrigerEditObjs;

}



export default changeManager
